import { PortalOrganisationDto } from './portal-organisation.dto';
import { PortalOrganisation } from 'app/domain/organisations/portal-organisation.model';

const LOCAL_HOST = 'localhost';

export function toPortalOrganisation(dto: PortalOrganisationDto): PortalOrganisation {
  return {
    organisationId: dto.organisationId,
    name: dto.name,
    logoUrl: dto.iconUrl,
    brandColor: dto.primaryTextColor,
    accentColor: dto.activeUiColor,
    landingPageUrl: landingPageUrlOf(dto.landingPageDomain),
  };
}

function landingPageUrlOf(domain: string | null | undefined): string | undefined {
  if (!domain) return undefined;
  const scheme = domain.split(':')[0] === LOCAL_HOST ? 'http' : 'https';
  return `${scheme}://${domain}`;
}
